/*!

=========================================================
* Now UI Dashboard PRO React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/now-ui-dashboard.scss?v=1.3.0";
import "assets/css/demo.css";
import "assets/icons/style.css";

import App from "App";
import store from "store/store";

// #ux-redesign-start: import ThemeProvider (light/dark, persistencia tsd-theme)
import { ThemeProvider } from "contexts/ThemeContext";
// #ux-redesign-end

ReactDOM.render(
  <Provider store={store}>
    {/* #ux-redesign-start: ThemeProvider envuelve <App> para que useTheme() esté disponible globalmente */}
    <ThemeProvider>
      <App />
    </ThemeProvider>
    {/* #ux-redesign-end */}
  </Provider>,
  document.getElementById("root")
);
